<script>
    import jQuery from "jquery";
    import GPSoilSettings from './gp-soilsettings.svelte';
    import GPLostChangesWarning from "./gp-lostchangeswarning.svelte";
    import GPAreYouSureWarning from "./gp-areyousurewarning.svelte";
    import GPItemList from "./gp-itemlist.svelte";
    import GPBloomTable from "./gp-bloomtable.svelte";
    import GPKeyboardShortcuts from "./gp-keyboardshortcuts.svelte";
    import GPDetailsPlant from "./gp-detailsplant.svelte";
    import GPDetailsStructure from "./gp-detailsstructure.svelte";
    import GPDetailsSnippet from "./gp-detailssnippet.svelte";
    import GPBackgroundPicker from "./gp-backgroundpicker.svelte";
    import GPUsersProjects from "./gp-usersprojects.svelte";
    import GPContactUs from "./gp-contactus.svelte";
    import GPUploadCustomObjectModal from "./gp-uploadcustomobject.svelte";
    import GPSave from "./gp-save.svelte";
    import GPSaveSnippet from "./gp-save-snippet.svelte";
    import GPTexturePicker from "./gp-texturepicker.svelte";
    import GPTexturePickerOptions from "./gp-texturepickeroptions.svelte";
    import GPStructurePicker from "./gp-structurepicker.svelte";
    import GPStructurePickerOptions from "./gp-structurepickeroptions.svelte";
    import GPPlantPicker from "./gp-plantpicker.svelte";
    import GPSnippetPicker from "./gp-snippetpicker.svelte";
    import GPSnippetPickerOptions from "./gp-snippetpickeroptions.svelte";
    import GPPlantPickerOptions from "./gp-plantpickeroptions.svelte";
    import GPCalibrator from "./gp-calibrator.svelte";
    import GPItemInstanceDetails from "./gp-iteminstancedetails.svelte";
    import GPLabelDialog from "./gp-labeldialog.svelte";
    import GPFixedCutter from "./gp-fixedcutter.svelte";
    import GPFixedCutterOptions from "./gp-fixedcutteroptions.svelte";
    import GPInpainting from "./gp-inpainting.svelte";
    import GPInpaintingOptions from "./gp-inpaintingoptions.svelte";
    import GPCloner from "./gp-cloner.svelte";
    import GPClonerOptions from "./gp-cloneroptions.svelte";
    import HSVAdjust from "./gp-hsvadjust.svelte";
    import {GPTutorial} from "./gp-tutorial";
    import {GPItem} from "./gp-item.js";
    import {GPPlant} from "./gp-plant.js";
    import {GPStructure} from "./gp-structure.js";
    import {GPStructure3D} from "./gp-structure3d.js";
    import {
        mode,
        season,
        showLabels,
        preferredNames,
        selectedItemSet,
        lightDirection,
        snippetsStore,
        magic,
        modeOffline,
        overwriteOnlineAvailable,
        overwriteOnlineName, unsavedChanges
    } from './gp.js';
    import {onMount, tick} from "svelte";
    import { fade, slide } from 'svelte/transition';
    import {GPCustomObject} from "./gp-customobject";
    import {getGPTransFunc} from "./gp-translations";
    import {GPTypeItem} from "./gp-typeitem";
    import {GPTypePlant} from "./gp-typeplant";
    import {GPTypeStructure} from "./gp-typestructure";
    import {GPTypeSnippet} from "./gp-typesnippet";

    let trans = getGPTransFunc("gp-app");
    let plantPicker;
    let structurePicker;
    let hsvAdjuster;
    let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    /**
     *
     * @type {"FMG"|"BHG"|"IOS"|"ELECTRON"}
     */
    export let appType;

    onMount(() => {
        jQuery(window).on('backgroundPickerOpen', ()=>{unsavedChangesWarning(backgroundPickerOpen)});
        jQuery(window).on('showSoilSettings', showSoilSettings);
        jQuery(window).on('showOnlineSaveModal', ()=>{GPSettings.storageClass.ensureLogged(showOnlineSaveModal, true)});
        jQuery(window).on('showOnlineSaveAsModal', ()=>{GPSettings.storageClass.ensureLogged(showOnlineSaveAsModal, true)});
        jQuery(window).on('showIOSSaveModal', showIOSSaveModal);
        jQuery(window).on('showIOSSaveAsModal', showIOSSaveAsModal);
        jQuery(window).on('undo', GP.undo);
        jQuery(window).on('newProject', ()=>{unsavedChangesWarning(GP.newProject)});
        jQuery(window).on('saveToFile', GP.saveToFile);
        jQuery(window).on('saveAsToFile', GP.saveAsToFile);
        jQuery(window).on('startOver', ()=>{unsavedChangesWarning(GP.startOver)});
        jQuery(window).on('openFromFile', () => GPSettings.storageClass.selectFileForOpening().then(GPSettings.storageClass.loadProjectFromFile).then(GP.readProject));
        jQuery(window).on('downloadImage', GP.downloadImageHandler);
        jQuery(window).on('showItemList',showItemList);
        jQuery(window).on('showBloomTable',showBloomTable);
        jQuery(window).on('printProjectView',GP.printProjectView);
        jQuery(window).on('shareByEmail',GP.shareByEmail);
        jQuery(window).on('pasteItems',GP.pasteItems);
        jQuery(window).on('uploadCustomObject', ()=>GPSettings.storageClass.ensureLogged(GP.GPUploadCustomObject));
        jQuery(window).on('zoomIn',GP.zoomIn);
        jQuery(window).on('zoomOut',GP.zoomOut);
        jQuery(window).on('toggleShowLabels', ()=>{$showLabels = !$showLabels});
        jQuery(window).on('togglePreferredNames', ()=>{$preferredNames = $preferredNames==="default"?"latin":"default"});
        jQuery(window).on('uploadBackground', ()=>{unsavedChangesWarning(GP.GPUploadBackground)});
        jQuery(window).on('startTutorial',GPTutorial.startTutorial);
        jQuery(window).on('showKeyboardShortcuts',showKeyboardShortcuts);
        jQuery(window).on('showUsersOnlineProjects', () =>{GPSettings.storageClass.ensureLogged(showUsersOnlineProjects, true)});
        jQuery(window).on('showIOSUsersProjects', showIOSUsersProjects);
        jQuery(window).on('contactUs', showContactUsForm);
        jQuery(window).on('switchLargeTextMode', GP.switchLargeTextMode);
        jQuery(window).on('closeApp', ()=>{unsavedChangesWarning(GPSettings.storageClass.closeApp)});
        jQuery(window).on('restorePurchasesFromAppStore', GPSettings.upgradeClass.restorePurchasesFromAppStore);
        jQuery(window).on('restorePurchasesFromServer', GPSettings.upgradeClass.restorePurchasesFromServerHandler);
        jQuery(window).on('loginToOnlineAccount', () => {GPSettings.storageClass.ensureLogged(() => {})});
        jQuery(window).on('desktopPrint', GP.desktopPrintProjectView);
        jQuery(window).on('logoutAndDeactivateProgram', () => {areYouSureWarning(
            trans("This will lock all the premium features of the app and the access to your online account. This will not delete your account nor projects and you will be able to restore your purchases if you re-login (here or on other computer)")
            ).then(GPSettings.upgradeClass.logoutAndDeactivateProgram).catch(()=>{})});
        jQuery(window).on('deleteCustomObject', (e) => {areYouSureWarning(
            trans("This operation cannot be undone.")
        ).then(() => GPSettings.storageClass.deleteCustomObject(e.detail)).catch(()=>{})});
        jQuery(window).on('showMessage', (e) => showMessage(e.detail));
        jQuery(window).on('deleteSnippet', (e) => {areYouSureWarning(
            trans("This operation cannot be undone.")
        ).then(() => GPSettings.storageClass.deleteSnippet(e.detail)).catch(()=>{})});
        jQuery(window).on('showMessage', (e) => showMessage(e.detail));
        jQuery(window).on('showItemDetails', () => {if ($selectedItemSet.length === 1) showDetailsOfItem($selectedItemSet[0])});
        jQuery(window).on('adjustSelectedItem', adjustSelectedItem);
        jQuery(window).on('upgrade', GPSettings.gotoUpgradeWebsite);

        jQuery(".GPPickerTab").on("focusin", function(){jQuery('.GPPickerArea').addClass("active")});
        jQuery(".GPPickerTab").on("focusout", function(){jQuery('.GPPickerArea').removeClass("active")});

        jQuery('.GPDesignViewport').on('mousewheel', function(e) {
            if (e.ctrlKey) {
                e.preventDefault();
                GP.zoomBy( e.originalEvent.wheelDelta / 1000, e.offsetX, e.offsetY );
            }
        });

        document.addEventListener('dragover', function (event) {
            event.preventDefault();
            return false;
        }, false);
        document.addEventListener('drop',GP.handleFileDrop,false);


        jQuery(".GPResizeBar").draggable({
            axis: "x",
            cursor: "ew-resize",
            drag: function (e) {
                var w = e.clientX - 15;
                if (w < 140) w = 140;
                if (w > (jQuery('.main').innerWidth() - 200)) w = jQuery('.main').innerWidth() - 200;
                if (w > 560) w = 560;
                jQuery('.main').css('grid-template-columns', w + 'px 8px auto');
                var evt = new CustomEvent('resize', {});
                window.dispatchEvent(evt);
            }
        });
    })

    export function showSoilSettings() {
        let component = new GPSoilSettings({
            target: document.body,
            props: {
                soilTypePH: GP.project.soilTypePH,
                soilTypeQuality: GP.project.soilTypeQuality,
                soilHumidity: GP.project.soilHumidity,
                zone: GP.project.zone,
                countryId: GP.project.ctr,
                regionId: GP.project.region,
                project: GP.project
            }});
        component.open();
    }

    export function showSaveSnippet() {
        if ($selectedItemSet.length < 2)
            GP.selectAllItems();

        //It can happen that the project has no plants, so we need to check it again
        if ($selectedItemSet.length < 2)
            return showMessage(trans("Add plants to the project first, before saving it as a plant arrangement."));

        let preview = GP.prepareSnippetPrev();
        let saveFunction =
            (name) => {
                return new Promise(async (resolve, reject) => {
                    let params = {};
                    params['name'] = name;
                    params['plants'] = GP.selectedItemsToSnippetData();
                    params['reference'] =  JSON.stringify({
                      "designWidth": GP.project.designWidth,
                      "horizonPos": GP.project.horizonPos,
                      "sizeX": GP.project.sizeX,
                      "sizeY": GP.project.sizeY
                    })
                    try {
                        let res = await GPSettings.storageClass.uploadSnippet(params, preview);
                        resolve(res['snippetId']);
                    } catch (e) {
                        reject();
                    }

                })
            };

        let saveSuccessFunction = (res) => {
            GP.loadSnippets().then(GP.processSnippets);
        }

        let component = new GPSaveSnippet({
            target: document.body,
                props: {
                    saveFunction: saveFunction,
                    saveSuccessFunction: saveSuccessFunction,
                    preview: preview
                }
            });
        component.open();
    }

    export function unsavedChangesWarning(nextAction, message) {
        if (GP.project.unsavedChanges) {
            let component = new GPLostChangesWarning({
                target: document.body,
                props: {
                    message: message
                }
            });
            component.open(nextAction);
        } else nextAction();
    }

    export function areYouSureWarning(message) {
        let component = new GPAreYouSureWarning({
            target: document.body,
            props: {
                message: message
            }
        });
        return component.open();
    }

    export function showMessage(message) {
        let component = new GPAreYouSureWarning({
            target: document.body,
            props: {
                message: message,
                confirmMode: false
            }
        });
        return component.open();
    }

    export function showItemList() {
        let component = new GPItemList({
            target: document.body,
            props: {
                project: GP.project
            }});
        component.open();
    }

    export function showBloomTable() {
        let component = new GPBloomTable({
            target: document.body,
            props: {
                project: GP.project
            }});
        component.open();
    }

    export function showKeyboardShortcuts() {
        let component = new GPKeyboardShortcuts({
            target: document.body
            });
        component.open();
    }

    /**
     *
     * @param {GPTypePlant|GPTypeStructure|GPTypeSnippet|GPItem} item
     */
    export function showDetailsOfItem(item) {
        if (item instanceof GPPlant) item = item.data;

        if (item instanceof GPTypePlant) {
            let component = new GPDetailsPlant({
                target: document.body,
                props: {
                    type: item
                }
            });
            component.open();
        }
        if (item instanceof GPTypeStructure) {
            let component = new GPDetailsStructure({
                target: document.body,
                props: {
                    type: item
                }
            });
            component.open();
        }
        if (item instanceof GPTypeSnippet) {
            let component = new GPDetailsSnippet({
                target: document.body,
                props: {
                    type: item
                }
            });
            component.open();
        }
    }

    export async function backgroundPickerOpen() {
        let component = new GPBackgroundPicker({
            target: document.body,
            props: {
                backgrounds: GP.backgrounds
            }
            });
        let selected = await component.open();
        GP.nextFocus = jQuery('#GPProjectView');
        if (selected) GP.changeBackground(selected);
    }

    export function showUsersOnlineProjects() {
        GPSettings.storageClass.getUsersOnlineProjects().then(res => {
            let component = new GPUsersProjects({
                target: document.body,
                props: {
                    projects: res.projects,
                    deleteFunction: GPSettings.storageClass.deleteOnlineProject
                }
                });
        component.open().then(project => GP.app.unsavedChangesWarning(function() {GP.userProjectLoadDetails(project.id)}))
        });
    }

    export function showIOSUsersProjects() {
        GPSettings.storageClass.getIOSUsersProjects().then(res => {
            let component = new GPUsersProjects({
                target: document.body,
                props: {
                    projects: res.projects,
                    deleteFunction: GPSettings.storageClass.deleteIOSProject
                }
                });
            component.open().then(project => GP.app.unsavedChangesWarning(() => {
                GPSettings.storageClass.loadIOSProjectDetails(project.id).then(function(res){return GP.readProject(res,project.id)});
            }));
        });
    }

    export function showContactUsForm() {
        let component = new GPContactUs({
            target: document.body
            });
        component.open();
    }


    export function showOnlineSaveModal() {
        return showSaveModal(GPSettings.storageClass.saveOnlineProject, true);
    }

    export function showOnlineSaveAsModal() {
        return showSaveModal(GPSettings.storageClass.saveOnlineProject, true, true);
    }

    export function showIOSSaveModal() {
        return showSaveModal(GPSettings.storageClass.saveIOSProject, false);
    }

    export function showIOSSaveAsModal() {
        return showSaveModal(GPSettings.storageClass.saveIOSProject, false, true);
    }

    /**
     *
     * @param {function} storageSaveFunc
     * @param {boolean} privateAllowed
     * @param {boolean = false} saveAs
     */
    function showSaveModal(storageSaveFunc, privateAllowed, saveAs) {
        /**
         *
         * @param {{title:string, private: boolean}} params
         * @returns {Promise}
         */
        let saveFunction =
            (params) => {
                params['data'] = GP.project.jsonify(true, true, true, true);
                params['thumb'] = GP.prepareSaveThumbnailImage();
                if (GP.project.savedId && storageSaveFunc === GPSettings.storageClass.saveOnlineProject && !saveAs)
                    params['projectId'] = String(GP.project.savedId);
                if (GP.project.savedIOSId && storageSaveFunc === GPSettings.storageClass.saveIOSProject && !saveAs)
                    params['projectId'] = String(GP.project.savedIOSId);
                if (GP.project.title && !saveAs)
                    params['title'] = String(GP.project.title);

                return storageSaveFunc(params);
            };

        let saveSuccessFunction = (res) => {
            GP.project.unsavedChanges = false;
            unsavedChanges.set(false);
            GP.project.savedId = parseInt(res['savedId']);
            GP.project.savedIOSId = parseInt(res['savedIOSId']);
            GP.project.title = res['title'];
            overwriteOnlineAvailable.set(!!GP.project.savedId);
            overwriteOnlineName.set(GP.project.title);
        }

        if (( (!GP.project.savedId || storageSaveFunc !== GPSettings.storageClass.saveOnlineProject) &&
              (!GP.project.savedIOSId || storageSaveFunc !== GPSettings.storageClass.saveIOSProject)) || saveAs) {
            let component = new GPSave({
                target: document.body,
                props: {
                    saveFunction: saveFunction,
                    saveSuccessFunction: saveSuccessFunction,
                    privateAllowed: privateAllowed
                }
            });
            component.open();
        } else {
            //overwrite
            GP.showWaiting();
            saveFunction({})
            .then((res) => {
                saveSuccessFunction(res);
                GP.clearWaiting();
            })
            .catch(() => {
                GP.clearWaiting();
                showMessage(trans("Save failed. Check network connection and try again."));
            });
        }
    }

    export function showUploadCustomObject(imgBase64) {
        let component = new GPUploadCustomObjectModal({
            target: document.body,
            props: {
                imgBase64: imgBase64
            }
            });
        component.open();
    }

    export function showCalibrator(url) {
        let component = new GPCalibrator({
            target: document.body
            });
        component.open(url);
    }

    export function switchSeason(s) {
        if (!GPSettings.products["four_seasons"].active) return GPSettings.upgradeClass.showOnlyInPremium("seasons");
        $season = s;
    }

    function switchMode(m) {
        $mode = m;
    }


    export async function findItemInPicker (itemInstance) {
        if (itemInstance instanceof GPPlant) {
            $mode = "Plants";
            await tick();
            plantPicker.findAndSelect(itemInstance);
        }
        if (itemInstance instanceof GPStructure || itemInstance instanceof GPStructure3D || itemInstance instanceof GPCustomObject  ) {
            $mode = "Structures";
            await tick();
            structurePicker.findAndSelect(itemInstance);
        }
    }

    async function adjustSelectedItem () {
        if ($selectedItemSet.length !== 1) return;
        let adjustmentMade = false;

        let applyAdjust = (ph, ps, pv) => {
            if ($selectedItemSet.length !== 1) return;
            if (!adjustmentMade) {
                GP.saveUndo("modifyItems", $selectedItemSet);
                adjustmentMade = true;
            }
            var adjustment = {
                h: ph,
                s: ps,
                v: pv
            };
            GP.project.adjustItem($selectedItemSet[0].id, adjustment);
        }

        let initialHSV = $selectedItemSet[0].adjustment ? $selectedItemSet[0].adjustment : {h:0, s:0, v:0};
        let res = await hsvAdjuster.getHSV(initialHSV, applyAdjust);
    }

</script>

<header class="header">
    <slot name="headerLeft"></slot>
    <div class="headerRight">
        <slot name="menu"></slot>
    </div>
</header>

<div class="messageAlerts"></div>

<div class="main">
    <ul class="nav nav-tabs GPModeTabs">
        <li role="presentation" class="GPPickerTab" class:active={$mode==="Plants"}><a on:click={()=>{$mode="Plants"}} href="#GPPlantPicker"><i class="fa fa-tree" aria-hidden="true"></i><span>{trans('Plants')}</span></a></li>
        <li role="presentation" class="GPPickerTab" class:active={$mode==="Structures"}><a on:click={()=>{$mode="Structures"}} href="#GPStructurePicker"><i class="fa fa-home" aria-hidden="true"></i><span>{trans("Structures")}</span></a></li>
        <li role="presentation" class="GPPickerTab" class:active={$mode==="Textures"}><a on:click={()=>{$mode="Textures"}} href="#GPTexturePicker"><i class="fa fa-paint-brush" aria-hidden="true"></i><span>{trans("Textures")}</span></a></li>
        {#if $snippetsStore && $snippetsStore.length}
            <li role="presentation" class="GPPickerTab" class:active={$mode==="Snippets"}><a on:click={()=>{$mode="Snippets"}} href="#GPSnippetsPicker"><i class="fa fa-project-diagram" aria-hidden="true"></i><span>{trans("Arrangements")}</span></a></li>
        {/if}
        {#if appType !== "BHG" && appType !== "ZielonyOgrodek"}
        <li role="presentation" class="GPPickerTab" class:active={$mode==="FixedCutter" || $mode==="Cloner" || $mode==="Inpainting" || $mode==="Tools"}><a on:click={()=>{$mode="Tools"}} href="#GPTools"><i class="fas fa-tools"></i><span>{trans("Tools")}</span></a></li>
        {/if}
    </ul>
    <div class="btn-group GPViewSettingsSubmenu">
        <button on:click={GP.zoomIn} tabindex="-1" type="button" class="btn btn-default" title={trans('Zoom in')} >
            <span><i class="fas fa-search-plus"></i></span>
        </button>
        <button on:click={GP.zoomOut} tabindex="-1" type="button" class="btn btn-default" title={trans('Zoom out')}>
            <span><i class="fas fa-search-minus"></i></span>
        </button>
        <div style="display: inline-block">
            <button tabindex="-1" type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title={trans('View options')}>
                <span><i class="far fa-eye"></i></span>
            </button>
            <ul class="dropdown-menu dropdown-menu-right">
                <li><a on:click={()=>{$lightDirection = (-1) * $lightDirection}} class:selected={$lightDirection<0}><span>{trans("Light from right")}</span></a></li>
                <li><a on:click={()=>{$showLabels = !$showLabels}} href="#" class:selected={$showLabels} ><span>{trans("Show labels")}</span> </a></li>
            </ul>
        </div>
        <div style="display: inline-block">
            <button tabindex="-1" type="button" class="btn btn-default dropdown-toggle GPSeasonSwitch" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title={trans('Change season')}>
                <span><i class="far fa-calendar"></i></span>
            </button>
            <ul class="dropdown-menu dropdown-menu-right GPSeasonSwitchMenu">
                <li><a on:click={()=>{switchSeason("w")}} class="GPSeasonButton" class:selected={$season==="w"}><span>{trans("Spring")}</span></a></li>
                <li><a on:click={()=>{switchSeason("l")}} class="GPSeasonButton" class:selected={$season==="l"}><span>{trans("Summer")}</span></a></li>
                <li><a on:click={()=>{switchSeason("j")}} class="GPSeasonButton" class:selected={$season==="j"}><span>{trans("Autumn")}</span></a></li>
                <li><a on:click={()=>{switchSeason("z")}} class="GPSeasonButton" class:selected={$season==="z"}><span>{trans("Winter")}</span></a></li>
            </ul>
            <ul class="dropdown-menu dropdown-menu-right GPSeasonSwitchMenuLower">
                {#each [1,2,3,4,5,6,7,8,9,10,11,12] as i}
                <li><a on:click={()=>{switchSeason(i)}} class="GPSeasonButton" class:selected={$season===i}>
                    <span>{trans(monthNames[i-1])}</span>
                </a></li>
                {/each}
            </ul>
        </div>
    </div>
    <div class="GPPickerArea">
        <div class="tab-content">
            {#if $mode==="Plants"}
            <div id="GPPlantPicker"  class="GPPlantPicker" transition:fade>
                <ul id="GPPlantPickerList" class="list-group">
                    <GPPlantPicker plants={GP.plantTypes} bind:this={plantPicker}/>
                </ul>
            </div>
            {/if}
            {#if $mode==="Structures"}
            <div id="GPStructurePicker" class="GPStructurePicker" transition:fade>
                <ul id="GPStructurePickerList" class="list-group">
                    <GPStructurePicker bind:this={structurePicker}/>
                </ul>
            </div>
            {/if}
            {#if $mode==="Textures"}
            <div id="GPTexturePicker" class="GPTexturePicker" transition:fade>
                <ul id="GPTexturePickerList" class="list-group">
                    <GPTexturePicker textures={GP.textures}/>
                </ul>
            </div>
            {/if}
            {#if $mode==="Tools" || $mode==="FixedCutter" || $mode==="Inpainting" || $mode==="Cloner"}
            <div id="GPTools" class="GPToolsPicker" transition:fade>
                <div class="GPToolsTabs">
                {#if !$modeOffline}
                  <div class="panel panel-inpainting">
                    <div class="panel-heading">
                      <h4 class="panel-title">
                        <a on:click={() => $mode="Inpainting"} role="button">
                           {trans("Remove existing plants automatically")}
                        </a>
                      </h4>
                    </div>
                    {#if $mode==="Inpainting"}
                        <div id="GPInpaitingTab" transition:slide|local>
                          <div class="panel-body">
                            <GPInpainting/>
                          </div>
                        </div>
                    {/if}
                  </div>
                {/if}
                  <div class="panel panel-cloner">
                    <div class="panel-heading">
                      <h4 class="panel-title">
                        <a on:click={() => $mode="Cloner"} role="button" >
                           {trans("Remove existing plants by cloning")}
                        </a>
                      </h4>
                    </div>
                    {#if $mode==="Cloner"}
                        <div id="GPClonerTab" transition:slide|local>
                          <div class="panel-body">
                            <div id="GPCloner"></div>
                              <GPCloner/>
                          </div>
                        </div>
                    {/if}
                  </div>
                  <div class="panel panel-fixedCutter">
                    <div class="panel-heading">
                      <h4 class="panel-title">
                        <a on:click={() => $mode="FixedCutter"} role="button">
                           {trans("Retain background objects")}
                        </a>
                      </h4>
                    </div>
                    {#if $mode==="FixedCutter"}
                        <div id="GPFixedCutterTab" transition:slide|local>
                          <div class="panel-body">
                            <GPFixedCutter/>
                          </div>
                        </div>
                    {/if}
                  </div>
                </div>
            </div>
            {/if}
            {#if $mode==="Snippets"}
            <div id="GPSnippetPicker" class="GPSnippetPicker" transition:fade>
                <ul id="GPSnippetPickerList" class="list-group">
                    <GPSnippetPicker/>
                </ul>
            </div>
            {/if}
        </div>
    </div>

    <div class="GPResizeBar"></div>

    <div class="GPDesignArea">
        <div class="GPDesignViewport">
            <div class="GPDesignPane">
                <div id="GPProjectView" class="GPProjectView panel panel-default" tabindex="0" role="application">
                </div>
                <div class="GPHorizonHint"></div>
                {#if $magic}
                    <div class="magic-bck">
                        <div class="bg1"></div>
                        <div class="bg2"></div>
                        <div class="bg3"></div>
                    </div>
                {/if}
            </div>
            <HSVAdjust bind:this={hsvAdjuster}/>
            {#if $selectedItemSet.length}
                <GPItemInstanceDetails/>
            {/if}
            <GPLabelDialog/>
        </div>
        <div id="GPWaiting">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>
</div>

{#if $mode==="Plants"}
    <div id="GPPlantSearchBlock" class="GPSearchBlock">
        <GPPlantPickerOptions/>
    </div>
{/if}
{#if $mode==="Structures"}
    <div id="GPStructureSearchBlock" class="GPSearchBlock">
        <GPStructurePickerOptions bind:hsvAdjuster={hsvAdjuster}/>
    </div>
{/if}
{#if $mode==="Textures"}
    <div id="GPTextureSearchBlock" class="GPSearchBlock">
        <GPTexturePickerOptions bind:hsvAdjuster={hsvAdjuster}/>
    </div>
{/if}
{#if $mode==="Snippets"}
    <div id="GPSnippetSearchBlock" class="GPSearchBlock">
        <GPSnippetPickerOptions/>
    </div>
{/if}
{#if $mode==="FixedCutter"}
    <div class="GPSearchBlock">
    <GPFixedCutterOptions/>
    </div>
{/if}
{#if $mode==="Inpainting"}
    <div class="GPSearchBlock">
    <GPInpaintingOptions/>
    </div>
{/if}

{#if $mode==="Cloner"}
    <div class="GPSearchBlock">
    <GPClonerOptions/>
    </div>
{/if}

